import { useEffect, useState } from 'react';
import { localUriFor } from '@/lib/offline-audio';
import { fixDropboxUrl } from '@/lib/utils';

/**
 * Resolves a track to a local file when it has been downloaded, and to the
 * remote URL otherwise.
 *
 * Starts on the remote URL and swaps once the lookup answers, so playback is
 * never held up waiting on the filesystem. `refreshKey` lets a caller re-run
 * the check after a download or a delete.
 */
export function useOfflineSrc(
  url: string | null | undefined,
  refreshKey = 0,
): string | undefined {
  const remote = url ? fixDropboxUrl(url) : undefined;
  const [src, setSrc] = useState<string | undefined>(remote);

  useEffect(() => {
    let cancelled = false;
    setSrc(remote);
    if (!url) return undefined;
    localUriFor(url).then((local) => {
      if (!cancelled && local) setSrc(local);
    });
    return () => {
      cancelled = true;
    };
  }, [url, remote, refreshKey]);

  return src;
}
